export const sideFeedIcon = (size: number) => (
	<svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M0 0V4C9.93 4 18 12.07 18 22H22C22 9.85 12.15 0 0 0ZM0 7V11C6.07 11 11 15.93 11 22H15C15 13.72 8.28 7 0 7ZM3 16C2.20435 16 1.44129 16.3161 0.87868 16.8787C0.316071 17.4413 0 18.2044 0 19C0 19.7956 0.316071 20.5587 0.87868 21.1213C1.44129 21.6839 2.20435 22 3 22C3.79565 22 4.55871 21.6839 5.12132 21.1213C5.68393 20.5587 6 19.7956 6 19C6 18.2044 5.68393 17.4413 5.12132 16.8787C4.55871 16.3161 3.79565 16 3 16Z"
			fill="black"
		/>
	</svg>
);
